import type { RootState } from '~/store';

export const isGlobalFetchingSelector = (state: RootState) => state.fetchingCounter.counter > 0;
export const globalFetchingLabelSelector = (state: RootState) => state.fetchingCounter.text;
